export default __webpack_public_path__ + "static/media/bi.fabe0fe7.svg";